<div class="firstDiv" style="margin-top: 10%">
  <div class="mainDiv">
    <h2 class="h2_font_size">Your Payment has been processed Successfully!</h2>
  </div>
  <div class="mainDiv" style="text-align: center">
    <button class="btn btn-primary" (click)="download()" id="downloadBtnStyle">
      Order History</button>&nbsp;&nbsp;&nbsp;&nbsp;
    <!-- <button class="btn btn-warning" (click)="go()">GO</button> -->
  </div>
</div>